/* eslint-disable react/no-danger */
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { Item, Segment, Popup, Icon } from 'semantic-ui-react';
import classnames from 'classnames';
import { shape, string, bool, func } from 'prop-types';
import moment from 'moment';
import {
  MESSAGE_TYPE_MEDIA,
  MESSAGE_TYPE_ATTACHMENT,
  MESSAGE_TYPE_TEXT,
  MESSAGE_TYPE_FILE,
} from 'Constants/message-types';
import { denormalizeConversationsByActiveClinic } from 'Selectors/webChat/consults';
import { connect } from 'react-redux';
import PersonAvatar from 'Containers/Teleconsult/Sidebar/List/ChatListGroup/PersonAvatar';
import * as Actions from 'Redux/modules/webChat/actions';
import MessageParent from 'Containers/Teleconsult/Main/Messages/MessageBody/MessageList/MessageItem/MessageParent';

import MessageRequestConsult from '../MessageBot/MessageRequestConsult/MessageRequestConsult';
import MessageFinishConsult from '../MessageBot/MessageFinishConsult/MessageFinishConsult';
import { copyToClipboard } from '../../../../../../../helpers/utils';
import { CONSULT_ACCEPTED } from '../../../../../../../constants/consults';

import MessageItemContent from './MessageItemContent';
import styles from './MessageItem.less';

const isAttachment = type => type === MESSAGE_TYPE_ATTACHMENT;

class MessageItem extends Component {
  handleCopy = () => {
    const { message } = this.props;
    copyToClipboard(message.message.text);
  };

  handleReply = async () => {
    const { message, setJumpMessage, onSetReply, listConversation } = this.props;
    await setJumpMessage(null);
    onSetReply(message);
    const conversationWithPrivateId = listConversation.find(
      e => e.latestConsult?.doctorConversationId === message.metadata?.conversationId,
    );
    document
      .getElementById(`composer_${message.metadata.conversationId || conversationWithPrivateId.id}`)
      ?.focus();
  };

  render() {
    const {
      message,
      isDoctor,
      name,
      avatar,
      prevMessage,
      nextMessage,
      userUuid,
      patient,
      openMedicalCertificate,
      hasDividerDate,
      conversation,
      setJumpMessage,
    } = this.props;
    const { user, type, id, sentAt } = message;
    const isUserMessageSamePrevious = prevMessage && prevMessage.user === user;
    const isUserMessageSameNext = nextMessage ? nextMessage.user === user : false;
    const hasShowAvatar = !isDoctor && !isUserMessageSameNext;
    const consultEnded = conversation?.latestConsult?.status === CONSULT_ACCEPTED;

    const classMessageItem = classnames({
      'same-user': isUserMessageSameNext && !hasShowAvatar,
      [styles.wrapMessageItem]: type === MESSAGE_TYPE_TEXT,
      [styles.wrapMessageItemFirst]:
        type === MESSAGE_TYPE_TEXT &&
        (!isUserMessageSamePrevious || hasDividerDate || prevMessage?.type !== MESSAGE_TYPE_TEXT),
      [styles.wrapMessageItemLast]:
        type === MESSAGE_TYPE_TEXT &&
        (hasShowAvatar || !isUserMessageSameNext || nextMessage?.type !== MESSAGE_TYPE_TEXT),
    });

    const isTypeAttachment = isAttachment(type);

    const classNameDoctor = classnames([styles?.wrapMessageItem], {
      me: isDoctor,
      action: isTypeAttachment,
      you: !isDoctor,
    });
    const classNameDescription = classnames({
      right: isDoctor,
      'message-media': type === MESSAGE_TYPE_MEDIA,
    });

    const isNotConsultMessage = type !== 'new_request' && type !== 'finish_consult';

    return (
      <Item className={classMessageItem} id={id}>
        {hasShowAvatar && (
          <PersonAvatar
            data={
              name || avatar
                ? { firstName: name.split(' ')[0], lastName: name.split(' ')[1], avatarUrl: avatar }
                : patient
            }
          />
        )}
        <Item.Content>
          {type === 'new_request' && <MessageRequestConsult message={message} />}
          {type === 'finish_consult' && <MessageFinishConsult message={message} />}
          {isNotConsultMessage && (
            <>
              {!!message?.parent && (
                <MessageParent
                  message={message}
                  isDoctor={isDoctor}
                  setJumpMessage={setJumpMessage}
                  userUuid={userUuid}
                />
              )}
              <div className={classNameDoctor}>
                <Popup
                  trigger={
                    <Item.Description as={Segment} compact className={classNameDescription} basic>
                      <MessageItemContent
                        message={message}
                        userUuid={userUuid}
                        openMedicalCertificate={openMedicalCertificate}
                      />
                    </Item.Description>
                  }
                  content={moment(sentAt).format('MMM DD - HH:mm').toUpperCase()}
                  inverted
                  size="tiny"
                  disabled
                  // disabled={message.type === MESSAGE_TYPE_ATTACHMENT}
                  position={isDoctor ? 'top right' : 'left center'}
                />
                {(type === MESSAGE_TYPE_TEXT ||
                  type === MESSAGE_TYPE_MEDIA ||
                  type === MESSAGE_TYPE_FILE) && (
                  <div className={styles.wrapAction}>
                    {type === MESSAGE_TYPE_TEXT && (
                      <Popup
                        trigger={
                          <div className={styles.wrapIconAction} onClick={this.handleCopy}>
                            <Icon name="copy" />
                          </div>
                        }
                        content="Copy"
                        inverted
                        size="tiny"
                        position="top center"
                      />
                    )}
                    {consultEnded && (
                      <Popup
                        trigger={
                          <div className={styles.wrapIconAction} onClick={this.handleReply}>
                            <Icon name="reply" />
                          </div>
                        }
                        content="Reply"
                        inverted
                        size="tiny"
                        position="top center"
                      />
                    )}
                  </div>
                )}
              </div>
            </>
          )}
        </Item.Content>
      </Item>
    );
  }
}

MessageItem.propTypes = {
  message: shape({
    isSending: bool,
  }),
  isDoctor: bool.isRequired,
  prevMessage: shape({}),
  nextMessage: shape({}),
  name: string.isRequired,
  avatar: string,
  userUuid: string.isRequired,
  openMedicalCertificate: func.isRequired,
};
MessageItem.defaultProps = {
  message: {
    isSending: false,
  },
  avatar: null,
  prevMessage: null,
  nextMessage: null,
};

const mapStateToProps = state => ({
  listConversation: denormalizeConversationsByActiveClinic(state),
  jumpMessage: state.webChat.messages.jumpMessage,
});

const mapDispatchToProps = {
  setJumpMessage: Actions.setJumpMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(MessageItem);
